import MuiTooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const Tooltip = styled(({ className, ...props }) => (
    <MuiTooltip {...props} classes={{ popper: className }} />
  ))(({ theme,maxWidth=240,backgroundColor="rgba(0, 0, 0, 0.9)",fontSize=12,color="white" }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor,
      color,
      maxWidth,
      fontWeight:700,
      fontSize,
      border: `1px solid rgba(0, 0, 0, 1)`,
      '& .MuiTooltip-arrow':{
        color:backgroundColor
      }
    },
  }));

  export default Tooltip;